<template>
	<tr>
		<td class="pl-2 pr-2 py-4 font-medium text-gray-900 leading-5">
			<!-- :class="offer.trade == 'SELL' ? 'text-green-500' : 'text-orange-500'" -->
			<!-- {{ offer.trade }} -->
			<!-- <crop-product-summary :tradable="offer" /> -->

			{{
				$cropOptions.getLocalizedLabel(
					offer.product.grade,
					$cropOptions.productGradeOptions
				)
			}}

			<!-- <br /> -->
			<!-- {{ __('Harvest') }}  -->
			<span class="text-sm text-gray-500 whitespace-nowrap"
				>{{ offer.product.origin }}
				{{ offer.product.harvest || __("n.a.") }}</span
			>
		</td>
		<td class="px-2 py-4 text-gray-500 text-sm xl:text-base">
			{{ $cropOptions.dateToString(offer, locale, true) }}
		</td>
		<td class="px-2 py-4 whitespace-nowrap text-gray-500">
			{{ offer.auction.qty_mt }} t, ca.
		</td>
		<td class="px-2 py-4 whitespace-nowrap text-gray-500">
			<form @submit.prevent="submit" class="flex justify-start">
				<div class="w-2/3 mr-2">
					<ui-select
						class="w-full mt-1"
						v-model="pricingStrategy"
						:options="pricingStrategyOptions"
						:allow-empty="false"
						:markInvalid="commodityIsExpired"
					/>
				</div>
				<div class="w-1/3">
					<span v-if="form.price.type == 'FLAT'">
						<ui-input-group
							:no-label="true"
							:required="true"
							:form="form"
							field="price.mt"
							@change="piNeedsUpdate = true"
							v-model="form.price.mt"
							class="w-full"
							:dp="2"
							suffix="€/t"
							:showAsInvalid="commodityIsExpired"
						/>
					</span>
					<span
						v-else-if="form.price.type == 'INDEXED'"
						class="flex gap-x-2 items-center"
					>
						<ui-input-group
							:no-label="true"
							:required="true"
							:form="form"
							field="price.basis"
							v-model="form.price.basis"
							class="w-full"
							:dp="2"
							suffix="€/t"
							:showAsInvalid="commodityIsExpired"
						/>
					</span>
				</div>
			</form>
		</td>

		<!--td class="px-2 py-4 text-gray-500 text-sm xl:text-base"></td-->

		<td class="px-2 py-4 whitespace-nowrap text-gray-500">
			{{
				$cropOptions.getLocalizedLabel(
					offer.location.mode,
					$cropOptions.locationModeOptions
				)
			}}
			{{ offer.location.address.zip }}
			{{ offer.location.address.city }}
		</td>

		<td class="px-2 py-4 whitespace-nowrap text-gray-500">
			<ui-button type="blank" v-on:click="submitForm()">
				<ui-icon class="text-orange text-2xl mr-3" name="fa-floppy-disk" />
			</ui-button>
			<ui-button class="mt-1" @click="showBidRemoveModal = true" type="blank">
				<ui-icon class="text-orange text-2xl" name="fa-trash" />
			</ui-button>
			<auction-remove-bid-modal
				:offer="offer"
				v-if="showBidRemoveModal"
				v-on:close="showBidRemoveModal = false"
			></auction-remove-bid-modal>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		bid: {
			type: Object,
			required: true,
		},
		idx: {
			type: Number,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.bid)),
			showBidRemoveModal: false,
		};
	},
	computed: {
		futuresOptions() {
			let tickers = {
					RAPE: "ECO",
					MAIZE: "EMA",
					FABA: null, // no futures available for FABA and PEA
					PEA: null,
				},
				desiredTicker = tickers[this.form.product.type] || "EBM";
			return (this.activeFutures || [])
				.filter((f) =>
					this.form.product.type == "MAIZE"
						? f.ticker_code == desiredTicker || f.ticker_code == "EBM"
						: f.ticker_code == desiredTicker
				)
				.sort((a, b) =>
					a.ticker_code > b.ticker_code
						? 1
						: b.ticker_code > a.ticker_code
						? -1
						: 0
				);
		},
		pricingStrategyOptions() {
			let o = [{ id: "FLAT.", label: this.__("Flat Price") }],
				o2 = [];
			//if (this.offer.trade == "BUY") {
			o2 = this.futuresOptions.map(function (f) {
				return {
					id: "INDEXED." + f.id,
					label: f.name,
				};
			});
			//}
			return o.concat(o2);
		},

		// a pricing strategy is either flat or indexed.<commodity future id>
		pricingStrategy: {
			get() {
				if (this.form.price.type == "FLAT") {
					return "FLAT.";
				} else if (this.form.price.type == "INDEXED") {
					return "INDEXED." + this.form.price.commodity_future_id;
				} else {
					throw "unknown price type: " + this.form.price.type;
				}
			},
			set(v) {
				let [priceType, commodityFutureId] = v.split(".");
				this.form.price.type = priceType;
				this.form.price.commodity_future_id =
					commodityFutureId == "" ? null : commodityFutureId;
				console.log(this.form.price.type);
			},
		},
		commodityIsExpired() {
			if (this.offer.commodityFuture && this.offer.commodityFuture.expired) {
				return true;
			}
			return false;
		},
	},

	methods: {
		submitForm() {
			console.log(this.form);
			let method = "patch";
			let endpoint =
				window.baseUrl + "/auction/bid/" + this.offer.id + "?show_list=1";
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					alert(__("Das Gebot wurde aktualisiert"));
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
				onError(e) {
					console.log("form submit error:", e);
				},
			});
		},
	},
};
</script>
